module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-199.f717d3c7.svg";